// ============================================================
// OMYA Digital Plant – Polish Translation Dictionary
// Usage: import { t } from '@/i18n';  then t('key')
// ============================================================

const pl = {
  // ── Navigation ──
  'nav.main': 'GŁÓWNE',
  'nav.additional': 'INNE',
  'nav.dashboard': 'Przegląd',
  'nav.supplyChain': 'Łańcuch produkcji',
  'nav.trucks': 'Przyjazdy',
  'nav.planning': 'Planowanie',
  'nav.orders': 'Zamówienia',
  'nav.sapIntegration': 'Integracja SAP',
  'nav.aiVision': 'AI / WIZJA',
  'tour.open': 'Przewodnik',
  'tour.next': 'Dalej',
  'tour.prev': 'Wstecz',
  'tour.done': 'Gotowe',
  'tour.welcome.title': 'Witamy w OMYA Digital Plant',
  'tour.welcome.text': 'W 2 minuty pokażemy, jak narzędzie obsługuje przyjazdy ciężarówek w Pomezí: dziś 10–15 aut dziennie nie przyjeżdża i nie daje znać. Przewodnik można w każdej chwili zamknąć i uruchomić ponownie.',
  'tour.states.title': 'Stan dzisiejszych załadunków',
  'tour.states.text': 'Na pierwszy rzut oka widać, ile załadunków jest bez informacji. Właśnie tę liczbę chcemy każdego dnia maksymalnie obniżyć.',
  'tour.perHour.title': 'Przyjazdy według godzin',
  'tour.perHour.text': 'Pokazuje szczyty 6–9 i 12–14 na tle przepustowości bram. Nikomu nie narzucamy okien, po prostu wiemy, co nas czeka. Na czerwono auta, o których nic nie wiemy.',
  'tour.banner.title': 'Co wymaga akcji',
  'tour.banner.text': 'Przegląd pokazuje tylko, co się dzieje. Tutaj widać, ile załadunków wymaga interwencji, a jednym kliknięciem przechodzi się do kolejki Akcji.',
  'tour.queue.title': 'Kolejka Akcji',
  'tour.queue.text': 'Planista widzi tylko to, co musi rozwiązać: ponaglić, zadzwonić, wysłać link dyspozytorowi, przeplanować. To, co rozwiąże, znika z kolejki. Celem jest pusta kolejka.',
  'tour.urgency.title': 'Monity do przewoźników o 13:00',
  'tour.urgency.text': 'O 13:00 system porównuje plan z rzeczywistością i sam kontaktuje się z właściwym przewoźnikiem przez SMS, WhatsApp lub e-mail, w jego języku. Planista tylko zatwierdza albo wszystko działa w pełni automatycznie.',
  'tour.replies.title': 'Odpowiedzi napływają na żywo',
  'tour.replies.text': 'Teraz działa pokaz: AI czyta odpowiedzi po polsku, GPS znajduje auto w drodze, a do tego, kto nie odpowie w ciągu 30 minut, system zadzwoni. Kolejka opróżnia się sama, planiście zostają dwa załadunki.',
  'tour.stats.title': 'Wyniki w liczbach',
  'tour.stats.text': 'Statystyki długoterminowe: niestawienia się bez awizacji, udział załadunków z informacją o 13:00, monity i auta na parkingu w Jeseníku, zawsze w porównaniu ze stanem sprzed pilotażu.',
  'tour.carriers.title': 'Ocena przewoźników',
  'tour.carriers.text': 'Kto awizuje, kto nie przyjeżdża i jak szybko odpowiada. Podstawa do kontraktów operacyjnych i negocjacji cenowych.',
  'tour.restart.title': 'Przewodnik w każdej chwili',
  'tour.restart.text': 'Tym przyciskiem uruchomią Państwo przewodnik ponownie, np. dla współpracowników. Dziękujemy za uwagę.',
  'nav.planSetup': 'Ustawienia planu',
  'nav.stats': 'Statystyki',
  'stats.title': 'Statystyki',
  'stats.demoData': 'Dane demo',
  'stats.demoHint': 'Przykład poglądowy: tak wyglądałyby statystyki po wdrożeniu monitów do przewoźników. Wartości wyjściowe według klienta.',
  'stats.kpiPeriod': 'Średnia z ostatnich 30 dni w porównaniu z okresem przed pilotażem',
  'stats.tab.overview': 'Przegląd KPI',
  'stats.tab.carriers': 'Przewoźnicy',
  'stats.carrier.name': 'Przewoźnik',
  'stats.carrier.trucks': 'aut',
  'stats.carrier.loadings': 'Załadunki',
  'stats.carrier.announcedPct': 'Awizowano',
  'stats.carrier.noShowPct': 'Niestawienie bez awizacji',
  'stats.carrier.outOfHours': 'Brak czasu pracy',
  'stats.carrier.replyMedian': 'Odpowiedź (mediana)',
  'stats.carrier.onTimePct': 'ETA ±30 min',
  'stats.carrier.legend': 'Strzałki: zmiana względem poprzedniego okresu tej samej długości (zielona = lepiej). Na czerwono: niestawienia bez awizacji 15 % i więcej. Kliknij przewoźnika, aby zobaczyć trend.',
  'stats.carrier.weeklyNoShows': 'Niestawienia bez awizacji tygodniowo',
  'stats.carrier.weeklyOnTime': 'Dokładność ETA tygodniowo',
  'stats.carrier.detailHint': 'Podstawa do kontraktów operacyjnych i negocjacji cenowych z przewoźnikiem. Dane demo.',
  'rating.title': 'Miesięczna ocena przewoźnika',
  'rating.open': 'Miesięczna ocena do druku',
  'rating.back': 'Powrót do przewoźników',
  'rating.month': 'Miesiąc',
  'rating.partial': 'niepełny',
  'rating.print': 'Drukuj',
  'rating.workDays': '{days} dni roboczych',
  'rating.pilotShare': 'automatyczne monity w {pct} % dni',
  'rating.thisMonth': 'Ten miesiąc',
  'rating.prevMonth': 'Poprzedni miesiąc',
  'rating.change': 'Zmiana',
  'rating.findings': 'Wnioski',
  'rating.finding.noShowAlarm': 'Niestawienia bez awizacji powyżej limitu 15 %: temat do umowy operacyjnej.',
  'rating.finding.noShowBetter': 'Niestawienia bez awizacji spadły w porównaniu z poprzednim miesiącem.',
  'rating.finding.noShowWorse': 'Niestawienia bez awizacji wzrosły w porównaniu z poprzednim miesiącem.',
  'rating.finding.slowReply': 'Wolno odpowiada na monity (mediana powyżej 30 min).',
  'rating.finding.onTime': 'Wiarygodne ETA: 90 % i więcej przyjazdów w oknie ±30 min.',
  'rating.notes': 'Notatki z rozmów',
  'rating.footer': 'OMYA Pomezí · Dane demo, wskaźniki jak w ocenie przewoźników w Statystykach.',
  'csv.export': 'Eksport CSV',
  'csv.date': 'Data',
  'csv.pilot': 'Pilotaż',
  'csv.planned': 'Planowane załadunki',
  'csv.country': 'Kraj',
  'csv.yes': 'tak',
  'csv.no': 'nie',
  'stats.tab.site': 'Teren zakładu',
  'stats.tab.reports': 'Raporty',
  'reports.readyToConnect': 'Gotowe do podłączenia',
  'reports.send': 'Wyślij e-mailem',
  'reports.sendToast': 'Wysyłka e-mailem jest gotowa do podłączenia. W wersji demo nic nie jest wysyłane.',
  'reports.daily.title': 'Podsumowanie dzienne',
  'reports.daily.schedule': 'Wysyłane w każdy dzień roboczy o 16:00 do planistów i ekspedycji',
  'reports.daily.planned': 'Zaplanowano',
  'reports.daily.loaded': 'Załadowano',
  'reports.daily.urgencies': 'Monity: {total}, w tym {auto} rozwiązanych automatycznie i {planner} przekazanych planiście.',
  'reports.daily.missing': 'Kto nie przyjechał',
  'reports.daily.open': 'Pozostało otwarte, zajmuje się planista',
  'reports.daily.none': 'Brak',
  'reports.weekly.title': 'Raport tygodniowy dla kierownictwa',
  'reports.weekly.schedule': 'Wysyłany w poniedziałek o 7:00',
  'reports.weekly.thisWeek': 'Ten tydzień',
  'reports.weekly.worst': 'Najbardziej problematyczni przewoźnicy',
  'reports.weekly.noShowShort': 'bez awizacji',
  'stats.site.heatmapTitle': 'Przyjazdy według dnia i godziny',
  'stats.site.heatmapHint': 'Średnia liczba przyjazdów na godzinę. Przepustowość bramy: {capacity} / h',
  'stats.site.heatmapLegend': 'Im ciemniej, tym bliżej przepustowości bramy. Na czerwono: więcej aut, niż brama obsłuży w ciągu godziny. Przepustowości są orientacyjne, potwierdzi je zakład.',
  'stats.site.gate.CLS': 'CLS (silos)',
  'stats.site.gate.PST': 'PST (palety)',
  'stats.site.dwellTitle': 'Czas na terenie zakładu',
  'stats.site.dwellHint': 'Mediana za wybrany okres; 90 % aut kończy w podanym czasie',
  'stats.site.silo': 'Silos',
  'stats.site.pallet': 'Palety',
  'stats.site.p90': '90 % do',
  'stats.site.dwellMinutes': 'Łącznie na terenie (brama → wyjazd)',
  'stats.site.waitMinutes': 'Oczekiwanie na załadunek',
  'stats.site.loadMinutes': 'Załadunek',
  'stats.last30': '30 dni',
  'stats.last90': '90 dni',
  'stats.beforePilot': 'przed pilotażem',
  'stats.pilotStart': 'Start pilotażu',
  'stats.unit.perDay': '/ dzień',
  'stats.unit.trucksPerNight': 'aut / noc',
  'stats.kpi.noShows': 'Niestawienia bez awizacji',
  'stats.kpi.informed': 'Załadunki z informacją o 13:00',
  'stats.kpi.urgencies': 'Monity do przewoźników',
  'stats.kpi.autoResolved': 'rozwiązano automatycznie',
  'stats.kpi.parking': 'Parking Jeseník',
  'stats.chart.noShows': 'Niestawienia bez awizacji dziennie',
  'stats.chart.noShowsHint': 'Auta, które nie przyjechały i nie dały znać. Przed pilotażem 10–15 dziennie (według klienta).',
  'stats.chart.informed': 'Załadunki z informacją o 13:00',
  'stats.chart.informedHint': 'Udział dzisiejszych załadunków, o których o 13:00 wiemy, czy i kiedy przyjadą.',
  'stats.chart.urgencies': 'Monity: rozwiązane automatycznie vs. przez planistę',
  'stats.chart.urgenciesHint': 'Przed pilotażem planista monitował ręcznie i nikt tego nie ewidencjonował.',
  'stats.chart.parking': 'Auta na parkingu w Jeseníku na noc',
  'stats.chart.parkingHint': 'Mniej aut bez czasu pracy kierowcy i bez awizacji oznacza mniejszą potrzebę parkingu buforowego.',
  'stats.series.auto': 'Automatycznie',
  'stats.series.planner': 'Planista',
  'stats.tab.urgency': 'Monity',
  'stats.urgency.period': 'Dni pilotażu w okresie: {days}, monitów łącznie: {total}',
  'stats.urgency.replyPct': 'Wskaźnik odpowiedzi',
  'stats.urgency.replyMedian': 'Mediana odpowiedzi',
  'stats.urgency.escalated': 'Eskalacja do rozmowy',
  'stats.urgency.escalatedHint': 'Bez odpowiedzi w ciągu 30 min',
  'stats.urgency.resolution': 'Automatycznie / planista',
  'stats.urgency.resolutionHint': 'Rozwiązane samoczynnie vs. przekazane planiście',
  'stats.urgency.byChannel': 'Monity według kanału',
  'stats.urgency.channel': 'Kanał',
  'stats.urgency.sent': 'Wysłano',
  'stats.urgency.cost': 'Koszty',
  'stats.urgency.czk': 'Kč',
  'stats.urgency.channelLegend': 'Pierwsza wiadomość idzie kanałem, z którego korzysta przewoźnik. Bez odpowiedzi w ciągu 30 minut następuje połączenie głosowe, potem planista. Czas odpowiedzi przy połączeniu liczony jest od wybrania numeru.',
  'stats.urgency.savingsTitle': 'Szacowane oszczędności miesięcznie',
  'stats.urgency.hoursPerMonth': 'h / miesiąc',
  'stats.urgency.savedHours': 'Zaoszczędzony czas planisty: monity, których nie musi już obsługiwać ręcznie',
  'stats.urgency.czkPerMonth': 'Kč / miesiąc',
  'stats.urgency.channelCost': 'Koszty wiadomości i połączeń',
  'stats.urgency.assumption': 'Założenie: ręczny monit zajmuje planiście {minutes} min (znaleźć kontakt, zadzwonić, zapisać wynik), miesiąc ma {days} dni roboczych. Ceny za wiadomość lub połączenie: {prices}. Dane demo, ceny orientacyjne.',
  'nav.views': 'Widoki strony',
  'ai.live': 'AI',
  'ai.demo': 'AI demo',
  'ai.liveHint': 'Odpowiedź od Claude (AI).',
  'ai.demoHint': 'Przygotowana odpowiedź demonstracyjna: klucz AI nie jest jeszcze ustawiony lub AI nie odpowiedziała.',
  'stats.value.title': 'Wartość pilotażu dla zakładu',
  'stats.value.month': 'miesiąc',
  'stats.value.roi': 'Zwrot {roi}× przy cenie {price} miesięcznie',
  'stats.value.parking': 'Parking Jeseník',
  'stats.value.parkingCalc': 'aut na noc {before} → {now} (−{pct} %) z {cost} Kč miesięcznie',
  'stats.value.noShows': 'Mniej niestawień bez awizacji',
  'stats.value.noShowsCalc': '{count} niestawień mniej miesięcznie × {cost} Kč',
  'stats.value.planner': 'Czas planisty',
  'stats.value.plannerCalc': '{hours} h × {cost} Kč',
  'stats.value.messages': 'Koszt wiadomości i połączeń',
  'stats.value.messagesCalc': 'SMS, WhatsApp, e-mail, połączenia głosowe',
  'stats.value.source.client': 'liczba od klienta',
  'stats.value.source.estimate': 'nasz szacunek',
  'stats.value.noShowCostInput': 'Koszt jednego niestawienia',
  'stats.value.priceInput': 'Cena oprogramowania miesięcznie',
  'stats.value.note': 'Koszt parkingu i niestawienia doprecyzujemy według danych OMYA.',
  'ai.energy.title': 'Zalecany plan mielenia na jutro',
  'ai.energy.hint': 'AI układa młyny w najtańszych godzinach według cen OTE. Koszty i oszczędność liczy aplikacja.',
  'ai.energy.recommend': 'Zaproponuj plan (AI)',
  'ai.energy.habit': 'Dziś (start o 6:00)',
  'ai.energy.plan': 'Według zalecenia',
  'ai.energy.saving': 'Oszczędność dziennie',
  'ai.energy.legend': 'Kolor = przedział cenowy (zielony tanio, czerwony szczyt), obrys = dzisiejszy zwyczaj. Ceny: modelowy dzień roboczy OTE.',
  'ai.doc.title': 'Dokument ze zdjęcia',
  'ai.doc.upload': 'Zrób zdjęcie lub wgraj dokument',
  'ai.doc.expected': 'oczekiwano',
  'ai.doc.attach': 'Zapisz do załadunku',
  'ai.doc.attached': 'Zapisano w komunikacji.',
  'ai.doc.tooLarge': 'Plik jest większy niż 4,8 MB.',
  'ai.doc.allMatch': 'wszystko zgadza się z załadunkiem',
  'ai.doc.type.cmr': 'CMR',
  'ai.doc.type.weighbridge': 'Kwit wagowy',
  'ai.doc.type.delivery-note': 'Dowód dostawy',
  'ai.doc.type.other': 'Inny dokument',
  'ai.doc.field.plate': 'Nr rej.',
  'ai.doc.field.orderId': 'Dostawa',
  'ai.doc.field.weight': 'Masa',
  'ai.voice.call': 'Zadzwoń głosem AI:',
  'ai.voice.ringing': 'Wybieram numer…',
  'ai.voice.inProgress': 'Trwa rozmowa',
  'ai.voice.ended': 'Rozmowa zakończona',
  'ai.voice.simulation': 'Symulacja rozmowy',
  'ai.voice.result': 'Wynik',
  'ai.voice.noAnswer': 'Dyspozytor nie odbiera, załadunek trafia do planisty.',
  'import.photo.upload': 'Wgraj zdjęcie lub PDF',
  'import.photo.read': 'AI odczytała {n} wierszy, sprawdź je poniżej.',
  'import.photo.demoNote': 'Bez klucza AI zamiast pliku wczytuje się przykładowy plan.',
  'import.photo.tooLarge': 'Plik jest większy niż 4,8 MB.',
  'ai.assistant.title': 'Asystent AI',
  'ai.assistant.ask': 'Zapytaj asystenta',
  'ai.assistant.thinking': 'Myślę…',
  'ai.assistant.back': 'Wróć do wyszukiwania',
  'ai.brief.prepare': 'Przygotuj materiały do rozmowy (AI)',
  'ai.brief.title': 'Materiały do rozmowy z przewoźnikiem',
  'ai.brief.goal': 'Cel',
  'ai.brief.arguments': 'Argumenty',
  'ai.brief.proposals': 'Proponowane warunki',
  'ai.brief.agreements': 'Co uzgodnić',
  'ai.brief.note': 'Projekt AI na podstawie liczb z miesiąca. Przed rozmową sprawdź i popraw.',
  'ai.replan.propose': 'Zaproponuj rozwiązanie (AI)',
  'ai.replan.title': 'Propozycja przeplanowania',
  'ai.replan.risk': 'Ryzyko',
  'ai.replan.accept': 'Przyjmij',
  'ai.replan.reject': 'Odrzuć',
  'ai.replan.accepted': 'Przyjęto: załadunek przeplanowany, zapis jest w komunikacji.',
  'ai.replan.rejected': 'Odrzucono, plan bez zmian.',
  'ai.comment.title': 'Komentarz AI',
  'ai.comment.loading': 'Piszę komentarz…',
  'ai.ask.title': 'Zapytaj statystyki',
  'ai.ask.placeholder': 'Np. Który przewoźnik najczęściej nie przyjeżdża bez awizacji?',
  'ai.ask.send': 'Zapytaj',
  'ai.ask.source': 'Źródło',
  'ai.ask.q1': 'Ile aut nie przyjeżdża bez awizacji i jak było przed pilotażem?',
  'ai.ask.q2': 'Który przewoźnik jest najbardziej problematyczny?',
  'ai.ask.q3': 'Ile czasu zaoszczędził automatyczny monit?',
  'ai.ask.q4': 'Jak zmienia się poinformowanie o 13:00?',
  'ai.reply.title': 'Symuluj odpowiedź przewoźnika',
  'ai.reply.placeholder': 'Wpisz odpowiedź przewoźnika, np. po polsku…',
  'ai.reply.read': 'Rozpoznaj odpowiedź',
  'ai.reply.unclear': 'Niejasne',
  'ai.reply.confidence': 'Pewność',
  'ai.reply.reason': 'Powód',
  'ai.reply.noTranslation': 'Tłumaczenie wymaga AI z kluczem.',
  'ai.reply.applied': 'Ustawiono automatycznie, odpowiedź jest w komunikacji.',
  'ai.reply.confirm': 'Potwierdź',
  'ai.reply.dismiss': 'Odrzuć',
  'ai.reply.readByAi': 'rozpoznane przez AI',
  'nav.focus': 'TERAZ ROZWIĄZUJEMY',
  'nav.concepts': 'MOŻLIWOŚCI / KONCEPCJE',
  'nav.conceptsHint': 'Pomysły na przyszłość, na razie bez rzeczywistych danych',
  'concept.badge': 'Koncepcja',
  'concept.hint': 'Przykład możliwego rozszerzenia. Dane są poglądowe, a moduł nie jest na razie objęty planem pilotażu.',
  'nav.branchDetection': 'Wykrywanie gałęzi',
  'nav.visualFactory': 'Visual Factory',

  // ── Detekce větví ──
  'branchDetection.title': 'Wykrywanie gałęzi',
  'branchDetection.description': 'Moduł AI do wykrywania gałęzi na przenośniku. Identyfikuje niepożądane zanieczyszczenia w kamieniu w czasie rzeczywistym.',
  'branchDetection.demo': 'Pokaz wykrywania',
  'branchDetection.detected': 'Wykryto',
  'branchDetection.branches': 'gałęzie',
  'branchDetection.accuracy': 'Dokładność',
  'branchDetection.zone': 'Strefa detekcji',
  'branchDetection.live': 'Na żywo',
  'branchDetection.label': 'gałąź',
  'branchDetection.shift.title': 'Zmiana poranna: znaleziska na taśmie',
  'branchDetection.shift.total': 'Znaleziska',
  'branchDetection.shift.perHour': 'Znaleziska na godzinę',
  'branchDetection.shift.note': 'Demonstracja koncepcji na danych ilustracyjnych. Prawdziwa wersja wymaga kamery nad taśmą i wytrenowanego modelu obrazu.',
  'branchDetection.outcome.ejected': 'Odrzucone klapą',
  'branchDetection.outcome.review': 'Do sprawdzenia',
  'branchDetection.outcome.false': 'Fałszywy alarm',

  // ── Header ──
  'header.search': 'Szukaj',
  'header.notifications': 'Powiadomienia',
  'header.activeAlerts': 'aktywnych alertów',
  'header.markAllRead': 'Oznacz wszystkie',
  'header.allClear': 'Wszystko w porządku',
  'header.live': 'LIVE',
  'header.profile': 'Profil',
  'header.settings': 'Ustawienia',
  'header.signOut': 'Wyloguj się',
  'header.justNow': 'przed chwilą',
  'header.minAgo': 'min temu',
  'header.hrAgo': 'godz. temu',
  'header.dAgo': 'dni temu',
  'header.language': 'Język',

  // ── Command Palette ──
  'cmd.placeholder': 'Szukaj zamówień, ciężarówek, węzłów...',
  'cmd.noResults': 'Brak wyników.',
  'cmd.pages': 'Strony',
  'cmd.orders': 'Zamówienia',
  'cmd.trucks': 'Ciężarówki',
  'cmd.supplyChainNodes': 'Węzły łańcucha produkcji',
  'cmd.util': 'wykorzystanie',

  // ── Dashboard ──
  'dashboard.title': 'Przegląd',
  'dashboard.plant': 'Zakład Pomezí',
  'dashboard.totalOutputToday': 'Łączna produkcja dziś',
  'dashboard.morningShift': 'Zmiana ranna',
  'dashboard.afternoonShift': 'Zmiana popołudniowa',
  'dashboard.nightShift': 'Zmiana nocna',
  'dashboard.all': 'Wszystko',
  'dashboard.am': 'Rano',
  'dashboard.pm': 'Popołudnie',
  'dashboard.night': 'Noc',
  'dashboard.operationsActive': 'Ruch aktywny',
  'dashboard.linesInOperation': 'linie w ruchu',
  'dashboard.loadings': 'załadunków',
  'dashboard.todaysOutput': 'Produkcja dziś',
  'dashboard.vsYesterday': 'vs wczoraj',
  'dashboard.plantUtilization': 'Wykorzystanie zakładu',
  'dashboard.linesActive': 'aktywne linie',
  'dashboard.oee': 'OEE',
  'dashboard.loadingsToday': 'Załadunki dziś',
  'dashboard.remaining': 'pozostało',
  'dashboard.qualityRate': 'Jakość',
  'dashboard.energyCost': 'Koszty energii',
  'dashboard.costPerTonne': 'Koszt za tonę',
  'dashboard.costPerTonneSub': 'OTE na żywo × zużycie mielenia',
  'dashboard.offPeakUntil': 'TARYFA NISKA do 14:00',
  'dashboard.productionLast7Days': 'Produkcja – ostatnie 7 dni',
  'dashboard.actual': 'Rzeczywistość',
  'dashboard.target': 'Cel',
  'dashboard.lineUtilization': 'Wykorzystanie linii',
  'dashboard.utilization': 'Wykorzystanie',
  'dashboard.activeAlerts': 'Aktywne alerty',
  'dashboard.oeeFull': 'OEE (całkowita efektywność urządzeń)',

  // ── KPI Card ──
  'kpi.target': 'Cel',
  'kpi.offPeakUntil14': 'TARYFA NISKA do 14:00',

  // ── KPI Drilldown ──
  'drilldown.title': 'Szczegóły',
  'drilldown.todayHourly': 'Dziś (godzinowo)',
  'drilldown.thisWeek': 'Ten tydzień',
  'drilldown.thisMonth': 'Ten miesiąc',
  'drilldown.peakHour': 'Szczyt',
  'drilldown.avgPerHour': 'Średnio/godz.',
  'drilldown.total': 'Łącznie',
  'drilldown.bestDay': 'Najlepszy dzień',
  'drilldown.weeklyAvg': 'Średnia tygodniowa',
  'drilldown.vsTarget': 'vs cel',
  'drilldown.monthTotal': 'Łącznie w miesiącu',
  'drilldown.week1': 'Tydzień 1',
  'drilldown.week2': 'Tydzień 2',
  'drilldown.week3': 'Tydzień 3',
  'drilldown.week4': 'Tydzień 4',

  // ── Alert Strip ──
  'alerts.allOperational': 'Wszystkie systemy działają — brak aktywnych alertów',
  'alerts.showLess': 'Pokaż mniej',
  'alerts.showAll': 'Pokaż wszystko',

  // ── Trucks Page ──
  'trucks.title': 'Przyjazdy',
  'trucks.enRoute': 'W drodze',
  'trucks.waiting': 'Czeka',
  'trucks.weighIn': 'Ważenie wjazd',
  'trucks.loading': 'Załadunek',
  'trucks.weighOut': 'Ważenie wyjazd',
  'trucks.departed': 'Odjechał',
  'trucks.total': 'Łącznie',
  'trucks.loadingTimeline': 'Oś czasu załadunków',
  'trucks.siteMap': "Teren teraz",
  'trucks.siteLayout': 'Plan terenu zakładu',
  'trucks.plant': 'ZAKŁAD',
  'trucks.omyaJesenik': 'OMYA Pomezí',
  'trucks.truckCount': 'ciężarówek',
  'trucks.weighBridge': 'WAGA',
  'trucks.searchPlaceholder': 'Szukaj ciężarówek...',

  // ── Truck Detail Sheet ──
  'truckDetail.overview': 'Przegląd',
  'truckDetail.timeline': 'Oś czasu',
  'truckDetail.order': 'Zamówienie',
  'truckDetail.load': 'Ładunek',
  'truckDetail.driver': 'Kierowca',
  'truckDetail.currentLoad': 'Aktualny ładunek',
  'truckDetail.loaded': 'załadowano',
  'truckDetail.remaining': 'pozostało',
  'truckDetail.progress': 'Postęp',
  'truckDetail.gate': 'Brama',
  'truckDetail.eta': 'Przyjazd',
  'truckDetail.event': 'Zdarzenie',
  'truckDetail.linkedOrder': 'Powiązane zamówienie',
  'truckDetail.noLinkedOrder': 'Brak powiązanego zamówienia',
  'truckDetail.documents': 'Dokumenty',
  'truckDetail.material': 'Materiał',
  'truckDetail.targetWeight': 'Masa docelowa',
  'truckDetail.currentWeight': 'Aktualna masa',
  'truckDetail.timestamps': 'Znaczniki czasu',
  'truckDetail.arrived': 'Przyjazd',
  'truckDetail.loadingStarted': 'Początek załadunku',
  'truckDetail.loadingTimeBySack': 'Czas załadunku / rodzaj opakowania',

  // ── Planning Page ──
  'planning.title': 'Planowanie',
  'planning.week': 'Tydzień',
  'planning.thisWeek': 'Ten tydzień',
  'planning.weekView': 'Widok tygodniowy',
  'planning.ganttView': 'Widok Gantta',
  'planning.capacity': 'Wydajność',
  'planning.scheduled': 'Zaplanowano',
  'planning.available': 'Wolne',
  'planning.materials': 'Materiały',
  'planning.weeklySummary': 'Podsumowanie tygodnia',
  'planning.plannedOutput': 'Planowana produkcja',
  'planning.actualOutput': 'Rzeczywista produkcja',
  'planning.completion': 'Realizacja',
  'planning.avgUtilization': 'Średnie wykorzystanie',
  'planning.energyTariffs': 'Taryfy energetyczne',
  'planning.off': 'NISKA',
  'planning.peak': 'SZCZYT',
  'planning.tariffStandard': 'ŚREDNIA',
  'planning.tariffNegative': 'UJEMNA',
  'planning.schedule': '+ Zaplanuj',
  'addPlanning.title': 'Dodaj planowanie',
  'addPlanning.material': 'Materiał',
  'addPlanning.order': 'Zamówienie',
  'addPlanning.selectOrder': 'Wybierz zamówienie',
  'addPlanning.noOrder': 'Bez zamówienia',
  'addPlanning.energyTariff': 'Taryfa energetyczna',
  'addPlanning.tariff': 'taryfa',
  'addPlanning.cancel': 'Anuluj',
  'addPlanning.add': 'Dodaj',
  'planning.now': 'Teraz',
  'planning.material.gcc': 'Wapień GCC',
  'planning.material.pcc': 'Wapień PCC',
  'planning.material.byproduct': 'Produkt uboczny',
  'planning.productionFlow': 'Przepływ produkcji',
  'planning.productionFlowDesc': 'Kamień (surowiec) → produkty wapienne (GCC/PCC) → produkt uboczny (CaCO3). Podczas przetwarzania kamienia powstają produkty główne i produkt uboczny.',
  'planning.mainProduction': 'Produkcja główna',
  'planning.byProduct': 'Produkt uboczny',
  'planning.fraction': 'Frakcja',
  'planning.fraction.sand': 'Piasek',
  'planning.fraction.fine': 'Drobna',
  'planning.fraction.standard': 'Standardowa',
  'planning.fraction.powder': 'Mączka',
  'planning.fractionCycleNote': 'czas cyklu na tonę',
  'planning.packagingLine': 'Linia pakująca',
  'planning.packaging.bigBag': 'Big bag (1 t)',
  'planning.packaging.bag25': 'Worki 25 kg',
  'planning.packaging.bag50': 'Worki 50 kg',
  'planning.packaging.bulk': 'Luzem (silos)',
  'planning.linkedTo': 'Powiązane z',
  'planning.linkedDeps': 'Produkcja powiązana',
  'planning.linkedDepsDesc': 'Produkcja tego materiału wymaga równoległej produkcji podanych pozycji.',
  'gantt.util': 'wykorz.',
  'gantt.planned': 'zaplanowano',

  // ── Days of week ──
  'day.mon': 'Pn',
  'day.tue': 'Wt',
  'day.wed': 'Śr',
  'day.thu': 'Cz',
  'day.fri': 'Pt',
  'day.sat': 'So',
  'day.sun': 'Nd',

  // ── Orders Page ──
  'orders.title': 'Zamówienia',
  'orders.totalOrders': 'Łącznie zamówień',
  'orders.totalValue': 'Łączna wartość',
  'orders.avgOrder': 'Średnie zamówienie',
  'orders.fulfillmentRate': 'Wskaźnik realizacji',
  'orders.allStatuses': 'Wszystkie statusy',
  'orders.pending': 'Oczekuje',
  'orders.confirmed': 'Potwierdzono',
  'orders.inProduction': 'W produkcji',
  'orders.produced': 'Wyprodukowano',
  'orders.dispatched': 'Wysłano',
  'orders.delivered': 'Dostarczono',
  'orders.searchPlaceholder': 'Szukaj według zamówienia, klienta lub materiału...',
  'orders.status': 'Status',
  'orders.number': '#',
  'orders.customer': 'Klient',
  'orders.items': 'Pozycje',
  'orders.progress': 'Postęp',
  'orders.value': 'Wartość',
  'orders.delivery': 'Dostawa',
  'orders.showing': 'Wyświetlono',
  'orders.of': 'z',
  'orders.ordersCount': 'zamówień',

  // ── Supply Chain ──
  'supplyChain.title': 'Łańcuch produkcji',
  'supplyChain.addWidget': 'Dodaj widżet',
  'supplyChain.widgetAdded': 'Widżet dodany',
  'supplyChain.widgetRemoved': 'Widżet usunięty',
  'supplyChain.node.quarry': 'Kamieniołom',
  'supplyChain.node.crusher': 'Kruszarka',
  'supplyChain.node.sorting': 'Sortowanie',
  'supplyChain.node.packaging': 'Pakowanie',
  'supplyChain.node.bulk': 'Luzem',
  'supplyChain.node.dispatch': 'Ekspedycja',
  'supplyChain.node.silo': 'Silos',
  'supplyChain.crusherTariffBadge': 'Kruszarka – aktualna taryfa',
  'supplyChain.crusherCostNow': 'Koszt za tonę (teraz)',
  'supplyChain.siloFillTime': 'czas napełniania',
  'supplyChain.siloCapacity': 'pojemność',
  'supplyChain.siloContent': 'zawartość',
  'supplyChain.bottleneck': 'Wąskie gardło',
  'supplyChain.legend': 'Legenda',
  'supplyChain.legend.nodeStatus': 'Stan węzła',
  'supplyChain.legend.operational': 'W ruchu',
  'supplyChain.legend.warning': 'Ostrzeżenie',
  'supplyChain.legend.errorBottleneck': 'Błąd / Wąskie gardło',
  'supplyChain.legend.flowStatus': 'Stan przepływu',
  'supplyChain.legend.activeFlow': 'Aktywny przepływ',
  'supplyChain.legend.reducedFlow': 'Ograniczony przepływ',
  'supplyChain.legend.stopped': 'Zatrzymano',
  'supplyChain.legend.capacity': 'Wydajność',
  'supplyChain.legend.capacityUnder60': '< 60 %',
  'supplyChain.legend.capacity60to85': '60–85 %',
  'supplyChain.legend.capacityOver85': '> 85 %',
  'supplyChain.status.operational': 'W ruchu',
  'supplyChain.status.warning': 'Ostrzeżenie',
  'supplyChain.status.error': 'Błąd',

  // ── SAP Integration ──
  'sap.title': 'Integracja SAP',
  'sap.heading': 'Integracja SAP S/4HANA',
  'sap.subtitle': 'Dwukierunkowa synchronizacja danych',
  'sap.omyaDigitalPlant': 'OMYA Cyfrowy zakład',
  'sap.supplyChainTrucks': 'Łańcuch produkcji · Ciężarówki',
  'sap.planningOrders': 'Planowanie · Zamówienia',
  'sap.restApi': 'REST API',
  'sap.middleware': 'Middleware',
  'sap.dataMapping': 'Mapowanie danych',
  'sap.validationAuth': 'Walidacja · Uwierzytelnianie',
  'sap.rfcOdata': 'RFC / OData',
  'sap.dataFlows': 'Przepływy danych',
  'sap.syncStatus': 'Stan synchronizacji',
  'sap.apiLog': 'Log API',
  'sap.dataType': 'Typ danych',
  'sap.direction': 'Kierunek',
  'sap.frequency': 'Częstotliwość',
  'sap.lastSync': 'Ostatnia synchr.',
  'sap.status': 'Status',
  'sap.productionOrders': 'Zlecenia produkcyjne',
  'sap.inventoryLevels': 'Stany magazynowe',
  'sap.customerMaster': 'Dane klientów',
  'sap.dispatchConfirmations': 'Potwierdzenia ekspedycji',
  'sap.loadingPlans': 'Plany załadunków',
  'sap.qualityResults': 'Wyniki jakości',
  'sap.materialSpecs': 'Specyfikacje materiałów',
  'sap.financialData': 'Dane finansowe',
  'sap.realTime': 'W czasie rzeczywistym',
  'sap.every5Min': 'Co 5 min',
  'sap.daily': 'Codziennie',
  'sap.onEvent': 'Przy zdarzeniu',
  'sap.every15Min': 'Co 15 min',
  'sap.weekly': 'Co tydzień',
  'sap.ppProduction': 'PP (Produkcja)',
  'sap.mmMaterials': 'MM (Materiały)',
  'sap.sdSales': 'SD (Sprzedaż)',
  'sap.qmQuality': 'QM (Jakość)',
  'sap.pmMaintenance': 'PM (Utrzymanie ruchu)',
  'sap.fiFinance': 'FI (Finanse)',
  'sap.recordsSynced': 'rekordów zsynchronizowano',
  'sap.synchronized': 'Zsynchronizowano',
  'sap.delayed': 'Opóźnione',
  'sap.time': 'Czas',
  'sap.method': 'Metoda',
  'sap.endpoint': 'Endpoint',
  'sap.duration': 'Czas trwania',
  'sap.infoTitle': 'Makieta wizualna.',
  'sap.infoText': 'Nie odbywa się żaden transfer danych. Pełna integracja SAP S/4HANA planowana jest na Q3 2026, w tym bezpieczne API, uwierzytelnianie SSO, logowanie audytowe i synchronizacja w czasie rzeczywistym.',

  // ── Login ──
  'login.welcomeBack': 'Witamy ponownie',
  'login.signInSubtitle': 'Zaloguj się, aby uzyskać dostęp do przeglądu',
  'login.email': 'E-mail',
  'login.emailPlaceholder': 'imie.nazwisko@omya.com',
  'login.password': 'Hasło',
  'login.forgot': 'Nie pamiętasz?',
  'login.passwordPlaceholder': 'Wpisz hasło',
  'login.signIn': 'Zaloguj się',
  'login.signingIn': 'Logowanie...',
  'login.demoMode': 'Tryb demo — akceptowane są dowolne dane logowania',

  // ── Production Order Dialog ──
  'prodDialog.utilization': 'Wykorzystanie',
  'prodDialog.planned': 'Zaplanowano',
  'prodDialog.actual': 'Rzeczywistość',
  'prodDialog.productionProgress': 'Postęp produkcji',
  'prodDialog.offPeak': 'TARYFA NISKA',
  'prodDialog.peak': 'SZCZYT',
  'prodDialog.shift': 'zmiana',
  'prodDialog.hourlyOutput': 'Produkcja godzinowa',
  'prodDialog.order': 'Zamówienie',

  // ── Gantt View ──
  'gantt.now': 'Teraz',

  // ── Shift labels ──
  'shift.morning': 'Ranna',
  'shift.afternoon': 'Popołudniowa',
  'shift.night': 'Nocna',

  // ── Add Widget Dialog ──
  'widget.addTitle': 'Dodaj widżet metryki',
  'widget.addDescription': 'Wybierz węzeł i metrykę do wyświetlenia na tablicy.',
  'widget.sourceNode': 'Węzeł źródłowy',
  'widget.selectNode': 'Wybierz węzeł...',
  'widget.metric': 'Metryka',
  'widget.selectMetric': 'Wybierz metrykę...',
  'widget.cancel': 'Anuluj',
  'widget.add': 'Dodaj widżet',
  'metric.oeeOverall': 'OEE łącznie',
  'metric.availability': 'Dostępność',
  'metric.performance': 'Wydajność',
  'metric.quality': 'Jakość',
  'metric.utilization': 'Wykorzystanie',
  'metric.currentOutput': 'Aktualna produkcja',
  'metric.maxCapacity': 'Maks. wydajność',
  'metric.activeAlerts': 'Aktywne alerty',
  'metric.hoursRun': 'Przepracowane godziny',

  // ── OEE Overlay ──
  'oee.plantOee': 'OEE zakładu',
  'oee.availability': 'Dostępność',
  'oee.performance': 'Wydajność',
  'oee.quality': 'Jakość',
  'oee.throughput': 'Przepustowość',

  // ── Node Detail Panel ──
  'node.currentOutput': 'Aktualna produkcja',
  'node.oeeBreakdown': 'Rozkład OEE',
  'node.availability': 'Dostępność',
  'node.performance': 'Wydajność',
  'node.quality': 'Jakość',
  'node.overall': 'Łącznie',
  'node.material': 'Materiał',
  'node.order': 'Zamówienie',
  'node.progress': 'Postęp',
  'node.throughput': 'Przepustowość',
  'node.uptime': 'Gotowość techniczna',
  'node.qualityRate': 'Wskaźnik jakości',
  'node.utilization': 'Wykorzystanie',
  'node.performanceRadar': 'Radar wydajności',
  'node.speed': 'Prędkość',
  'node.energy': 'Energia',
  'node.output': 'Produkcja',
  'node.actual': 'Rzeczywistość',
  'node.target': 'Cel',

  // ── Orders filter ──
  'orders.statusFilter': 'Status',

  // ── Visual Factory ──
  'visualFactory.title': 'Visual Factory',
  'visualFactory.panel.capacity': 'Wydajność i wykorzystanie',
  'visualFactory.panel.orders': 'Dzisiejsze zamówienia',
  'visualFactory.panel.trucks': 'Ciężarówki w tej chwili',
  'visualFactory.panel.ote': 'Taryfa energetyczna',
  'visualFactory.now': 'TERAZ',
  'visualFactory.utilized': 'Wykorzystane',
  'visualFactory.free': 'Wolne',
  'visualFactory.alerts': 'Alerty',
  'visualFactory.shift': 'Zmiana',
  'visualFactory.costPerTonne': 'Koszt / tona',
  'visualFactory.exitFullscreen': 'Zamknij pełny ekran',
  'visualFactory.todayProduced': 'Wyprodukowano dziś',
  'visualFactory.expected': 'Powinniśmy być na',
  'visualFactory.shiftRemaining': 'Do końca zmiany',
  'visualFactory.productionLines': 'Linie produkcyjne',
  'visualFactory.silosAndTrucks': 'Silosy i ciężarówki',
  'visualFactory.target': 'cel',
  'visualFactory.fullIn': 'Pełny za',
  'visualFactory.truckEta': 'Auto',
  'visualFactory.collision': 'Kolizja',
  'visualFactory.collisionLegend': 'Czerwony = silos pełny przed przyjazdem auta',
  'visualFactory.noTruck': 'Brak auta w planie',
  'visualFactory.expeditionToday': 'Ekspedycja dziś',
  'visualFactory.trucksOnSite': 'Aut na terenie',
  'visualFactory.waitingOver30': 'czekają > 30 min',
  'visualFactory.maintenance': 'Utrzymanie ruchu',
  'visualFactory.daysSinceIncident': 'Dni bez wypadku',
  'visualFactory.tickerPeak': 'Zalecane ograniczenie mielenia drobnych frakcji, zaplanować poza szczytem',
  'visualFactory.tickerNegative': 'Ujemna cena — dobry moment na operacje energochłonne',
  'visualFactory.tickerOffPeak': 'Tania taryfa — dobry moment na mielenie mączki i drobnych frakcji',
  'visualFactory.tickerStandard': 'Taryfa standardowa',
  'visualFactory.backToApp': 'Powrót do aplikacji',
  'visualFactory.whatIsThis': 'Co tu widzę?',
  'visualFactory.bannerHint': 'Czarna linia = gdzie powinniśmy być w tej chwili. Biały słupek = ile wyprodukowaliśmy.',
  'visualFactory.linesHint': 'Stan 3 linii produkcyjnych. Zielony = pracuje zgodnie z celem, żółty = wolna praca, czerwony = zatrzymana.',
  'visualFactory.silosHint': 'Napełnienie silosów + ETA aut. Czerwona ramka = silos zapełni się przed przyjazdem auta (produkcja stanie).',
  'visualFactory.tariffTicker': 'Taryfa energetyczna (dolny pasek)',
  'visualFactory.footerInfo': 'Dolny pasek — ekspedycja, utrzymanie ruchu, bezpieczeństwo',
  'visualFactory.aboutIntro': 'Ten ekran jest przeznaczony na telewizor w hali zakładu. Bez logowania, każdy widzi stan produkcji na pierwszy rzut oka. Odświeża się co 30 sekund.',
  'visualFactory.aboutBanner': 'Duży baner u góry. Tonaż wyprodukowany dziś vs plan dzienny, plus szacunek czasu pozostałego do końca zmiany. Czarna pionowa linia wskazuje wartość, na której powinniśmy być w tej chwili (gdyby wszystko szło zgodnie z planem).',
  'visualFactory.aboutLines': 'Trzy kafelki — po jednym na linię produkcyjną. Kolorowa dioda pokazuje stan (zielony/żółty/czerwony wg ISA-101). Jeśli linia pracuje wolno lub stoi, kafelek pokazuje przyczynę i stoper od kiedy.',
  'visualFactory.aboutSilos': 'Główna część ekranu. Dla każdego silosu: aktualne napełnienie, wyliczenie, kiedy będzie pełny przy obecnym tempie produkcji, oraz ETA najbliższej ciężarówki. Czerwona ramka = kolizja: silos przepełni się, zanim dotrze ciężarówka → trzeba natychmiast dzwonić do dyspozytora transportu.',
  'visualFactory.aboutFooter': 'Ekspedycja dziś (podział CZ/PL), liczba ciężarówek na terenie zakładu (i ile z nich czeka ponad 30 minut), aktywne prace utrzymania ruchu z ETA, dni bez wypadku.',
  'visualFactory.aboutTicker': 'Aktualna taryfa energetyczna OTE + zalecenia dla planowania produkcji (szczyt = ograniczyć drobne frakcje, poza szczytem/ujemna = dobry moment).',
  'visualFactory.aboutFooterNote': 'Żadnych danych wrażliwych (nazwiska kierowców, marże, polscy klienci). Ekran jest publiczny w obrębie zakładu.',

  // ── Status (utils.js) ──
  'status.ok': 'OK',
  'status.warning': 'Ostrzeżenie',
  'status.problem': 'Problem',

  // ── Dashboard additions ──
  'dash.arrivals.title': 'Przyjazdy dziś',
  'dash.arrivals.urgency': 'Monity do przewoźników o 13:00',
  'dash.arrivals.open': 'Otwórz przyjazdy',
  'dash.arrivals.informed': 'Z informacją',
  'dash.parking.title': 'Parking Jeseník',
  'dash.parking.month': 'miesiąc',
  'dash.parking.source': 'Koszt według klienta (szacunek)',
  'dash.parking.goal': 'Cel: ograniczyć parking dzięki awizowanym przyjazdom.',
  'dash.mobileWarning': 'Uwaga — aplikacja jest zoptymalizowana pod PC. Na telefonie może nie działać w 100%.',
  'dash.productionScorecard': 'Ocena produkcji',
  'dash.productionScorecardDesc': 'Moduł ocenia stan produkcji — wdrożenie przez zewnętrznego dostawcę',

  // ── Trucks ──
  'trucks.weighBridgeLabel': 'Waga',
  'trucks.wbActive': 'Aktywna',
  'trucks.wbIdle': 'Bezczynna',
  'trucks.wbLast': 'Ostatnie',
  'trucks.loadingSlots': 'Okna załadunku',
  'trucks.addSlot': 'Dodaj slot',
  'trucks.slotFree': 'Wolne',
  'trucks.qr.dontComeNow': 'Proszę teraz nie jechać',
  'trucks.qr.youCanComeSlotFree': 'Można jechać, slot jest wolny',
  'trucks.qr.delay30': 'Proszę opóźnić przyjazd o 30 min',
  'trucks.qr.goToWeighbridge': 'Proszę wjechać na wagę',
  'trucks.qr.waitAtGate': 'Proszę czekać przy bramie',
  'trucks.dm.hourAway': 'Jestem godzinę od was',
  'trucks.dm.in45': 'Będę za 45 min',
  'trucks.dm.atGate': 'Jestem przy bramie',
  'trucks.dm.loadingDone': 'Załadunek skończony?',
  'trucks.dm.thanksDriving': 'Dziękuję, jadę',
  'trucks.toast.messageSent': 'Wiadomość wysłana (demo)',
  'trucks.noMessagesYet': 'Brak wiadomości',
  'trucks.typeMessage': 'Napisz wiadomość...',
  'trucks.simulateDriverMessage': 'Symuluj wiadomość od kierowcy',
  'truckDetail.communication': 'Komunikacja',
  'truckDetail.calling': 'Dzwonię',

  // ── Orders / Layout / Header ──
  'layout.digitalPlant': 'CYFROWY ZAKŁAD',
  'header.markAllReadToast': 'Wszystkie powiadomienia oznaczono jako przeczytane',
  'orders.actionSimulated': 'Akcja symulowana — tryb demo',
  'orders.confirm': 'Potwierdź',
  'orders.dispatch': 'Wyślij',
  'orders.invoice': 'Faktura',
  'orders.tab.overview': 'Przegląd',
  'orders.tab.items': 'Pozycje',
  'orders.tab.timeline': 'Oś czasu',
  'orders.tab.delivery': 'Dostawa',
  'orders.ico': 'NIP',
  'orders.createdAt': 'Utworzono',
  'orders.confirmedAt': 'Potwierdzono',
  'orders.material': 'Materiał',
  'orders.quantity': 'Ilość',
  'orders.pricePerTon': 'Cena/t',
  'orders.total': 'Łącznie',
  'orders.productionProgress': 'Postęp produkcji',
  'orders.linkedTrucks': 'Powiązane ciężarówki',
  'orders.noTrucks': 'Brak ciężarówek',
  'orders.certificates': 'Certyfikaty',
  'orders.noCertificates': 'Brak certyfikatów',

  // ── Planning ──
  'plan.howItWorks': 'Jak działa planowanie?',
  'plan.howItWorksDesc': 'Moduł planowania optymalizuje produkcję na podstawie danych wejściowych i generuje plan dla wszystkich linii produkcyjnych.',
  'plan.input': 'Wejście',
  'plan.inputOrders': 'Zamówienia i wymagane materiały',
  'plan.inputCapacities': 'Wydajności linii produkcyjnych',
  'plan.inputAvailability': 'Dostępność materiałów i surowców',
  'plan.inputTariffs': 'Taryfy energetyczne (szczyt / taryfa niska)',
  'plan.output': 'Wyjście',
  'plan.outputWeeklyPlan': 'Tygodniowy plan produkcji (tabela / Gantt)',
  'plan.outputAssignment': 'Przypisanie materiałów do linii i zmian',
  'plan.outputTariffOpt': 'Optymalizacja według taryf energetycznych',
  'plan.outputTonnes': 'Planowana i rzeczywista produkcja w tonach',
  'plan.oteOverlay': 'Warstwa OTE',
  'plan.oteOverlayToggle': 'Przełącz warstwę energetyczną OTE',
  'plan.oteSpotNote': 'OTE spot, CZK/MWh, bez VAT i dystrybucji',
  'plan.oteSpotDaily': 'OTE spot — krzywa dzienna',
  'plan.oteRecord': 'Rekord 5/2024',
  'plan.oteTypical': 'Typowy dzień',
  'plan.min': 'Min',
  'plan.avg': 'Średnia',
  'plan.max': 'Maks',
  'plan.inNegative': 'na minusie',
  'plan.negativeRecordSource': '• minimum −138,75 EUR/MWh • źródło OTE a.s.',
  'plan.czkPerMWh': 'CZK/MWh',
  'plan.annualSavingsPotential': 'Roczny potencjał oszczędności',
  'plan.savingsAssumption': 'Przeniesienie 50 % mielenia ze szczytu do pasma offpeak/ujemnego OTE.',
  'plan.czkPerYear': 'CZK/rok',
  'plan.czkPerWeek': 'CZK/tydzień',
  'plan.pctOfPowerBill': '% rachunku za prąd',
  'plan.specificEnergy': 'Jednostkowe zużycie mielenia',
  'plan.peakTonnageWeek': 'Tonaż w szczycie (tydzień)',
  'plan.baselineNoOpt': 'Baseline (bez optymalizacji)',
  'plan.czk': 'CZK',
  'plan.assumptionsTuning': 'Założenia dopracowujemy na podstawie rzeczywistego zużycia od Petra.',

  // ── Node detail panel ──
  'node.tab.overview': 'Przegląd',
  'node.tab.production': 'Produkcja',
  'node.tab.maintenance': 'Utrzymanie ruchu',
  'node.tab.connections': 'Powiązania',
  'node.currentBatch': 'Aktualna partia',
  'node.output24h': 'Produkcja 24h',
  'node.weeklyOutputVsTarget': 'Produkcja tygodniowa vs cel',
  'node.equipment': 'Urządzenie',
  'node.manufacturer': 'Producent',
  'node.model': 'Model',
  'node.installed': 'Instalacja',
  'node.operatingHours': 'Godziny pracy',
  'node.nextMaintenance': 'Następny przegląd',
  'node.days': 'dni',
  'node.maintenanceHistory': 'Historia utrzymania ruchu',
  'node.date': 'Data',
  'node.type': 'Typ',
  'node.description': 'Opis',
  'node.duration': 'Czas trwania',
  'node.unplanned': 'Nieplanowana',
  'node.scheduled': 'Planowana',
  'node.alerts': 'Alerty',
  'node.linkedOrders': 'Powiązane zamówienia',
  'node.noLinkedOrders': 'Brak powiązanych zamówień',
  'node.linkedTrucks': 'Powiązane ciężarówki',
  'node.noLinkedTrucks': 'Brak ciężarówek przy tym węźle',

  // ── Mock data (dynamic content used in alerts, timelines, line labels) ──
  'mock.line1': 'Linia 1',
  'mock.line2': 'Linia 2',
  'mock.line3': 'Linia 3',
  'mock.alert.line2Overload': 'Linia 2 – Przeciążenie (92 %)',
  'mock.alert.noInfoLoadings': 'Załadunki bez informacji – monity do przewoźników o 13:00',
  'mock.alert.pstQueue': 'Brama PST – 3 ciężarówki czekają',
  'mock.alert.dispatchOk': 'Ekspedycja – w porządku',
  'mock.alert.crusherBearingTemp': 'Temperatura łożyska kruszarki rośnie',
  'mock.alert.tariffPeakSwitch': 'Przełączenie taryfy na SZCZYT o 14:00',
  'mock.alert.orderPending': 'Zamówienie ORD-2024-1845 czeka na potwierdzenie',
  'mock.alert.truckEta45': 'Ciężarówka 5L9 2341 przyjazd za 45 min',
  'mock.line.stopReason.slowMillVibration': 'Wolny młyn — drgania powyżej progu',
  'mock.event.dispatch': 'Wyjeżdża z bazy',
  'mock.event.arriveGate': 'Przyjazd do bramy',
  'mock.event.weighEmpty123': 'Ważenie: 12,3 t (pusty)',
  'mock.event.weighEmpty128': 'Ważenie: 12,8 t (pusty)',
  'mock.event.weighEmpty131': 'Ważenie: 13,1 t (pusty)',
  'mock.event.weigh125': 'Ważenie: 12,5 t',
  'mock.event.weigh130': 'Ważenie: 13,0 t',
  'mock.event.weighInProgress': 'Trwa ważenie',
  'mock.event.loadingStartedPST': 'Rozpoczęto załadunek na PST',
  'mock.event.loadingStartedCLS': 'Rozpoczęto załadunek na CLS',
  'mock.event.loadingStarted': 'Rozpoczęto załadunek',
  'mock.event.weighOut365': 'Ważenie wyjazdowe: 36,5 t',
  'mock.event.weighOut368': 'Ważenie wyjazdowe: 36,8 t (załadowany)',
  'mock.event.dispatched': 'Wysłano',
  'mock.event.arrived': 'Przyjechał',
  'mock.event.departed': 'Odjechał',
  'mock.event.departedFacility': 'Opuścił teren zakładu',
  'mock.event.waitingGate': 'Czeka na przydział bramy',
  'mock.event.waitingSlot': 'Czeka na slot',
  'mock.note.received': 'Przyjęto',
  'mock.note.receivedEmail': 'Zamówienie przyjęte e-mailem',
  'mock.note.receivedPhone': 'Przyjęto telefonicznie',
  'mock.note.receivedPortal': 'Przyjęto przez portal',
  'mock.note.receivedOrderEmail': 'Zamówienie przyjęte e-mailem',
  'mock.note.receivedOrderPortal': 'Zamówienie przyjęte przez portal',
  'mock.note.receivedOrder': 'Zamówienie przyjęte',
  'mock.note.confirmed': 'Potwierdzono',
  'mock.note.confirmedSales': 'Potwierdzone przez dział sprzedaży',
  'mock.note.confirmedSalesTeam': 'Potwierdzone przez zespół sprzedaży',
  'mock.note.started': 'Rozpoczęto',
  'mock.note.startedLine1': 'Rozpoczęto na Linii 1',
  'mock.note.startedLine2': 'Rozpoczęto na Linii 2',
  'mock.note.startedLine3': 'Rozpoczęto na Linii 3',
  'mock.note.productionStarted': 'Rozpoczęto produkcję',
  'mock.note.productionStartedLine1': 'Rozpoczęto produkcję na Linii 1',
  'mock.note.productionStartedLine2': 'Rozpoczęto produkcję na Linii 2',
  'mock.note.productionDone': 'Produkcja zakończona',
  'mock.note.productionDoneWaiting': 'Produkcja zakończona, czeka na ekspedycję',
  'mock.note.done': 'Zakończono',
  'mock.note.nightShift': 'Zmiana nocna',
  'mock.note.dispatched': 'Wysłano',
  'mock.note.dispatchedTwoTrucks': 'Wysłano – 2 ciężarówki',
  'mock.note.dispatchedDopravaPlus': 'Wysłano przez Doprava Plus',
  'mock.note.loadedDispatched': 'Załadowano i wysłano',
  'mock.note.loadedOnTruck1J4': 'Załadowano na ciężarówkę 1J4 9921',
  'mock.note.delivered': 'Dostarczono',
  'mock.note.deliveredSigned': 'Dostarczono i podpisano',
  'mock.nodeAlert.vibrationOverThreshold': 'Czujnik drgań powyżej progu',
  'mock.nodeAlert.bearingTemp78': 'Temperatura łożyska rośnie – 78 °C',
  'mock.nodeAlert.crusherChamberWear72': 'Zużycie komory kruszarki 72 %',
  'mock.dm.hourAway': 'Jestem godzinę od was',
  'mock.dm.gateReady': 'Rozumiemy, brama PST będzie przygotowana',
  'mock.dm.arriveIn45': 'Będę za 45 min',
  'mock.dm.holdSlot': 'Proszę teraz nie jechać, czekamy na zwolnienie slotu',
  'mock.dm.waitingParking': 'OK, czekam na parkingu',
  'mock.dm.slotFree': 'Można jechać, slot jest wolny',
  'mock.dm.atGate': 'Jestem przy bramie',
  'mock.dm.goToScale': 'Proszę wjechać na wagę',
  'mock.dm.loadingDone': 'Załadunek skończony?',
  'mock.dm.goToExitScale': 'Tak, proszę jechać na wagę wyjazdową',
  'mock.dm.delay30': 'Proszę opóźnić przyjazd o 30 min',
  'mock.dm.arriveLater': 'Rozumiem, przyjadę później',
  'mock.dm.eta45': 'ETA 45 minut',
  'mock.dm.preparingCLS': 'Dziękujemy, przygotowujemy slot CLS',
  'mock.ote.historicalLabel': '12.05.2024 (niedziela)',
  'mock.ote.typicalLabel': 'Typowy dzień roboczy',
  'mock.equipment.crusher': 'Kruszarka',
  'mock.day.Po': 'Pn',
  'mock.day.Út': 'Wt',
  'mock.day.St': 'Śr',
  'mock.day.Čt': 'Cz',
  'mock.day.Pá': 'Pt',
  'mock.day.So': 'So',
  'mock.day.Ne': 'Nd',
  // ── Příjezdy a nakládky / urgence ──
  'arrivals.state.no-info': 'Bez informacji',
  'arrivals.state.not-coming': 'Nie przyjedzie',
  'arrivals.state.no-power': 'Brak czasu pracy',
  'arrivals.state.rescheduled': 'Przeplanowano',
  'arrivals.state.confirmed': 'Potwierdzono',
  'arrivals.state.en-route': 'W drodze (GPS)',
  'arrivals.state.on-site': 'Na terenie zakładu',
  'arrivals.state.loaded': 'Załadowano',
  'arrivals.channel.sms': 'SMS',
  'arrivals.channel.whatsapp': 'WhatsApp',
  'arrivals.channel.email': 'E-mail',
  'arrivals.channel.phone': 'Telefon',
  'arrivals.channel.voice': 'Połączenie głosowe',
  'arrivals.channel.link': 'Link dla kierowcy',
  'arrivals.channel.gps': 'GPS',
  'arrivals.channel.system': 'System',
  'arrivals.channel.sap': 'SAP',
  'arrivals.perHour': 'Oczekiwane przyjazdy według godzin',
  'arrivals.perHourHint': 'Według ETA, w przeciwnym razie według planu. Bez okien załadunku, tylko przegląd szczytów.',
  'arrivals.known': 'Z informacją',
  'arrivals.unknown': 'Bez informacji',
  'arrivals.gateCapacity': 'Przepustowość bram',
  'arrivals.filter.all': 'Wszystkie',
  'arrivals.filter.attention': 'Wymaga uwagi',
  'arrivals.filter.open': 'Niezaładowane',
  'arrivals.filter.loaded': 'Załadowane',
  'arrivals.filter.risk': 'Wysokie ryzyko',
  'ai.risk.label': 'Ryzyko niestawienia',
  'ai.risk.high': 'Wysokie ryzyko',
  'ai.risk.medium': 'Średnie ryzyko',
  'ai.risk.low': 'Niskie ryzyko',
  'ai.risk.reason.carrier': 'Przewoźnik nie stawił się bez awizacji przy {pct} % załadunków w 30 dni',
  'ai.risk.reason.noInfo': 'Brak informacji od przewoźnika',
  'ai.risk.reason.noPower': 'Kierowca bez czasu pracy',
  'ai.risk.reason.rescheduled': 'Już raz przeplanowano',
  'ai.risk.reason.confirmed': 'Przewoźnik potwierdził przyjazd',
  'ai.risk.reason.enRoute': 'Auto w drodze (GPS)',
  'ai.risk.reason.afternoon': 'Załadunek popołudniowy, więcej niestawień',
  'ai.risk.reason.outOfHours': 'Przewoźnik {n}× w 30 dni bez czasu pracy kierowcy',
  'ai.risk.reason.noPlate': 'Z importu, jeszcze bez nr rej.',
  'ai.risk.note': 'Szacunek z historii przewoźnika i dzisiejszego stanu, nie wytrenowany model.',
  'arrivals.type.all': 'Wszystkie',
  'arrivals.type.silo': 'Silos',
  'arrivals.type.pallet': 'Palety',
  'arrivals.searchPlaceholder': 'Szukaj nr rej., przewoźnika, kierowcy, dostawy...',
  'arrivals.emptyFilter': 'Brak pozycji. Wszystkie załadunki w tym filtrze są rozwiązane.',
  'arrivals.plan': 'Plan',
  'arrivals.eta': 'Przyjazd',
  'arrivals.tomorrow': 'jutro',
  'arrivals.loadedAt': 'Załadowano',
  'arrivals.toPlanner': 'Przekazano planiście',
  'arrivals.powerFrom': 'czas pracy od',
  'arrivals.plannedToday': 'Zaplanowano dziś',
  'actions.bannerText': 'załadunków wymaga akcji – ponaglenie, telefon lub przeplanowanie.',
  'actions.open': 'Otwórz akcje',
  'actions.title': 'Akcje',
  'actions.progress': 'Rozwiązano',
  'actions.hint': 'Załadunki, przy których trzeba coś zrobić. Co rozwiążesz, zniknie z kolejki.',
  'actions.empty': 'Wszystko rozwiązane',
  'actions.emptyHint': 'Żaden załadunek nie wymaga teraz akcji.',
  'actions.urge': 'Ponaglić',
  'actions.urged': 'Ponaglono',
  'actions.urgedToast': 'Ponaglenie wysłane do przewoźnika',
  'actions.call': 'Zadzwonić',
  'actions.link': 'Link dla dyspozytora',
  'actions.replan': 'Przeplanować',
  'actions.resolve': 'Rozwiązane',
  'actions.newTime': 'Nowa godzina',
  'actions.replannedTo': 'Przeplanowane przez planistę na',
  'actions.note': 'Notatka',
  'actions.notePlaceholder': 'Co się stało (np. ustalone telefonicznie)',
  'actions.resolvedNote': 'Rozwiązane przez planistę',
  'actions.confirm': 'Potwierdź',
  'arrivals.tabToday': 'Dzisiejsze załadunki',
  'arrivals.readyToConnect': 'Gotowe do podłączenia',
  'arrivals.showTranscript': 'Pokaż transkrypcję rozmowy',
  'arrivals.hideTranscript': 'Ukryj transkrypcję',
  'arrivals.urgency.title': 'Monity do przewoźników',
  'arrivals.urgency.rule': 'Kontrola o 13:00 · eskalacja po 30 min: 2. kanał → połączenie głosowe',
  'arrivals.urgency.approval': 'Z zatwierdzeniem',
  'arrivals.urgency.approvalHint': 'System przygotowuje wiadomości, planista wysyła je jednym kliknięciem.',
  'arrivals.urgency.auto': 'W pełni automatycznie',
  'arrivals.urgency.autoHint': 'System sam wysyła monity i zgłasza planiście tylko to, czego nie rozwiązał.',
  'arrivals.urgency.run': 'Uruchom kontrolę 13:00',
  'arrivals.urgency.queue': 'Do monitowania',
  'arrivals.urgency.sendAll': 'Monituj wszystkie',
  'arrivals.urgency.result': 'Załadunki bez informacji',
  'arrivals.urgency.resultHint': 'Planista zajmuje się tylko tym, co zostało. Ręczne obdzwanianie odpada.',
  'arrivals.urgency.reset': 'Odtwórz ponownie',
  'arrivals.urgency.empty': 'O 13:00 system porównuje plan załadunków z rzeczywistością i kontaktuje się z przewoźnikami, o których nic nie wiemy.',
  'arrivals.detail.carrier': 'Przewoźnik',
  'arrivals.detail.prefers': 'preferuje',
  'arrivals.detail.emailDemo': 'E-mail otwarty (demo)',
  'arrivals.detail.driver': 'Kierowca',
  'arrivals.detail.name': 'Imię i nazwisko',
  'arrivals.detail.power': 'Czas pracy',
  'arrivals.detail.powerUnknown': 'nieznany',
  'arrivals.detail.fromPlant': 'od zakładu',
  'arrivals.detail.parking': 'Parking',
  'arrivals.detail.parkingJesenik': 'Parking buforowy Jeseník',
  'arrivals.detail.loading': 'Załadunek',
  'arrivals.detail.order': 'Dostawa (SAP)',
  'arrivals.detail.customer': 'Klient',
  'arrivals.detail.material': 'Materiał',
  'arrivals.detail.type': 'Typ',
  'arrivals.detail.communication': 'Komunikacja',
  'arrivals.detail.noMessages': 'Brak komunikacji',
  'arrivals.detail.auto': 'automatycznie',
  'arrivals.ai.confirmed': 'AI: potwierdzono, przyjazd {time}',
  'arrivals.ai.rescheduled': 'AI: dziś nie, przeplanowano na jutro {time}',
  'arrivals.ai.noPower': 'AI: kierowca bez czasu pracy, załadunek jutro 6:00, parkuje w Jeseníku',
  'arrivals.log.check': 'Kontrola 13:00: {total} załadunków bez informacji. {gps} zlokalizowano przez GPS, {queue} do monitowania.',
  'arrivals.log.gps': 'GPS: auto jest {km} km od zakładu, ETA {time}. Monit nie jest potrzebny.',
  'arrivals.log.gpsShort': 'GPS: {km} km od zakładu, ETA {time}',
  'arrivals.log.sapNew': 'Nowa dostawa z SAP {order}, przypisana przewoźnikowi {carrier}.',
  'arrivals.log.escalate': '30 min bez odpowiedzi ({ids}): próbuję drugiego kanału.',
  'arrivals.log.call': 'Połączenie głosowe: {name}, {phone}',
  'arrivals.log.callNoAnswer': 'Połączenie głosowe: {name} nie odbiera. Przekazano planiście.',
  'arrivals.log.callNoAnswerShort': 'Połączenie nieodebrane, przekazano planiście',
  'arrivals.log.done': 'Monitowanie zakończone. Zostało tylko to, czym musi zająć się człowiek.',

  // ── Help tips (#113) ──
  'help.label': "Pomoc",
  'help.states.title': "Stany ciężarówek",
  'help.states.text': "Ile ciężarówek jest w jakim stanie. Zielony = w porządku, pomarańczowy = uwaga, czerwony = problem. Kliknij ciężarówkę na liście, aby zobaczyć szczegóły.",
  'help.perHour.title': "Przyjazdy na godzinę",
  'help.perHour.text': "Ile ciężarówek ma przyjechać w każdej godzinie. Wysoki słupek = kolejka przy bramie. Warto to rozłożyć.",
  'help.filters.title': "Filtry",
  'help.filters.text': "Kliknij, aby zobaczyć tylko ciężarówki, które cię interesują. Kliknij ponownie, aby usunąć filtr.",
  'help.actions.title': "Akcje",
  'help.actions.text': "Co trzeba teraz zrobić. Najważniejsze na górze. Załatw sprawę, a pozycja zniknie.",
  'help.followUp.title': "Ponaglenia przewoźników",
  'help.followUp.text': "O 13:00 system sprawdza, kto nie potwierdził jutrzejszego załadunku, i pisze do przewoźnika. Nie musisz nikomu dzwonić.",
  'help.approval.title': "Automatycznie lub z akceptacją",
  'help.approval.text': "Automatycznie: wiadomości wychodzą same. Z akceptacją: najpierw je widzisz i potwierdzasz jednym kliknięciem.",
  'help.risk.title': "Ryzyko niestawienia się",
  'help.risk.text': "Jak bardzo grozi, że ciężarówka nie przyjedzie. Liczone z historii przewoźnika. Wysokie ryzyko = zadzwoń wcześniej.",
  'help.announce.title': "Link dla dyspozytora",
  'help.announce.text': "Wysyła przewoźnikowi link. Dyspozytor sam wpisze numer rejestracyjny i kierowcę. Bez przepisywania z e-maili.",
  'help.reply.title': "Symuluj odpowiedź",
  'help.reply.text': "Napisz odpowiedź jak przewoźnik, np. „przyjedziemy dopiero jutro”. AI ją przeczyta i zaproponuje zmiany.",
  'help.replan.title': "Propozycja zmiany planu",
  'help.replan.text': "AI proponuje nowy czas załadunku. Jeśli się zgadzasz, kliknij Akceptuj. W przeciwnym razie nic nie rób.",
  'help.voice.title': "Rozmowa głosem AI",
  'help.voice.text': "AI dzwoni do dyspozytora i pyta o przyjazd. Wynik zapisuje się sam przy załadunku.",
  'help.doc.title': "Dokument ze zdjęcia",
  'help.doc.text': "Zrób zdjęcie dokumentu dostawy lub CMR. AI odczyta liczby i je wpisze. Sprawdź i potwierdź.",
  'help.importPaste.title': "Wklej plan",
  'help.importPaste.text': "Skopiuj plan z Excela lub e-maila i wklej go tutaj. System sam utworzy załadunki.",
  'help.importPhoto.title': "Plan ze zdjęcia",
  'help.importPhoto.text': "Masz plan tylko na papierze? Zrób zdjęcie lub wgraj PDF. AI przepisze go za ciebie.",
  'help.period.title': "Okres",
  'help.period.text': "Wybierz okres, który chcesz zobaczyć. Wszystkie wykresy poniżej się przeliczą.",
  'help.kpis.title': "Główne liczby",
  'help.kpis.text': "Cztery liczby, po których poznasz, czy to działa. Strzałka pokazuje zmianę względem czasu przed pilotem.",
  'help.ask.title': "Zapytaj",
  'help.ask.text': "Napisz pytanie zwykłym zdaniem, np. „Który przewoźnik najczęściej się spóźnia?”. AI odpowie na podstawie liczb z tej strony.",
  'help.carriers.title': "Przewoźnicy",
  'help.carriers.text': "Kto jeździ dobrze, a kto nie. Czerwony = często nie przyjeżdża. Kliknij przewoźnika, aby zobaczyć więcej.",
  'help.value.title': "Wartość pilotu",
  'help.value.text': "Ile system oszczędza miesięcznie. Liczby w polach możesz zmienić, a wynik się przeliczy.",
  'help.heatmap.title': "Kiedy przyjeżdżają ciężarówki",
  'help.heatmap.text': "Ciemniejsze pole = więcej ciężarówek w danym dniu i godzinie. Widać, kiedy na terenie jest najtłoczniej.",
  'help.reports.title': "Raporty",
  'help.reports.text': "Gotowe zestawienia na spotkanie. Wystarczy otworzyć, wydrukować lub wysłać.",
  'help.rating.title': "Ocena przewoźnika",
  'help.rating.text': "Miesięczne świadectwo dla przewoźnika. Wydrukuj lub wyślij jako PDF. Pomoc się nie drukuje.",
  'help.energy.title': "Plan mielenia",
  'help.energy.text': "AI proponuje, kiedy mielić, aby trafić na tanią energię. Jeśli plan ci odpowiada, przejmij go.",
  'help.ai.title': "AI czy AI demo",
  'help.ai.text': "AI = tę odpowiedź właśnie napisał Claude. AI demo = przygotowana przykładowa odpowiedź, gdy AI nie jest włączona.",
  // ── Site now (#115) ──
  'site.title': "Teren teraz",
  'site.summary': "Aut na terenie: {total}.",
  'site.lateSummary': "{late} z nich jest tu dłużej niż {limit} minut.",
  'site.lateHint': "Stoi tu za długo. Sprawdź dlaczego – czekanie kosztuje.",
  'site.onSite': "na terenie",
  'site.empty': "Nikt",
  'site.zone.queue': "Kolejka przy bramie",
  'site.zone.PST': "Załadunek PST (palety)",
  'site.zone.CLS': "Załadunek CLS (silosy)",
  'site.zone.weighbridge': "Waga",
  'help.siteNow.title': "Teren teraz",
  'help.siteNow.text': "Kto jest teraz na terenie i gdzie stoi. Duża liczba = czas w tym miejscu, mała = czas na terenie łącznie. Czerwony = ponad 45 minut, kliknij i działaj.",
  // ── Today's sections (#117) ──
  'arrivals.section.action': "Wymaga działania",
  'arrivals.section.onSite': "Na terenie",
  'arrivals.section.enRoute': "W drodze",
  'arrivals.section.confirmed': "Potwierdzone",
  'arrivals.section.later': "Przesunięte",
  'arrivals.section.loaded': "Załadowane",
  'arrivals.typeLabel': "Typ",
  // ── Recommended action (#118) ──
  'actions.more': "Więcej…",
  'actions.recommended': "Zalecane",
  'actions.reason.noInfo': "przewoźnik jeszcze się nie odezwał, wyślij wiadomość.",
  'actions.reason.noAnswer': "ponaglenie bez odpowiedzi, zadzwoń.",
  'actions.reason.noPower': "kierowcy skończył się czas pracy, przesuń załadunek.",
  'arrivals.urgency.bar.idle': "Kontrola jeszcze się nie odbyła.",
  'arrivals.urgency.bar.review': "Wiadomości czekają na wysłanie.",
  'arrivals.urgency.bar.done': "Kontrola zakończona.",
  'arrivals.urgency.bar.sending': "Wysyłam wiadomości do przewoźników…",
  'arrivals.urgency.barToggle': "Pokaż przebieg ponagleń",
};

export default pl;
